import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props){ super(props); this.state={ hasError:false, info:null }; }
  static getDerivedStateFromError(){ return { hasError:true }; }
  componentDidCatch(error, info){ this.setState({ info }); /* optional: report */ }

  render(){
    if (this.state.hasError){
      return (
        <div style={{ padding:24 }}>
          <h2>Something went wrong.</h2>
          <p>Please refresh the page. If it continues, contact support.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
